// extracted by mini-css-extract-plugin
export var settingsList = "_30-0";
export var settingsRow = "_30-1";
export var warningDot = "_30-2";